<template>
  <div class="data-center">
    <a-tabs size="large">
      <a-tab-pane
        v-for="dataCenter in dataCenters"
        :key="dataCenter.id"
        :tab="dataCenter.title.rendered"
        :force-render="true"
      >
        <div class="container">
          <div class="row">
            <div class="col-xl-3">
              <h3 class="data-center__title">
                {{ $i18n.locale === 'ru' ? 'Дата-центр' : '' }} &laquo;{{ dataCenter.title.rendered }}&raquo;
              </h3>
            </div>
            <div class="col-xl-9">
              <div class="data-center__info">
                <div class="data-center__about">
                  <div class="data-center__specifications">
                    <div
                      v-for="item in dataCenter.acf.info.items"
                      :key="item.id"
                      class="data-center__specifications-item"
                    >
                      <h3
                        v-if="item.value"
                        class="h2"
                        v-html="item.value"
                      ></h3>
                      <div
                        class="data-center__specifications-description"
                        v-html="item.description"
                      ></div>
                    </div>
                  </div>

                  <div class="data-center__address-group">
                    <p
                      class="data-center__about-address"
                      v-html="dataCenter.acf.info.address"
                    ></p>
                    <!--                    <s-document link="#">-->
                    <!--                      Путеводитель по дата-центру-->
                    <!--                    </s-document>-->
                  </div>
                </div>

                <data-center-list-gallery
                  v-if="dataCenter.acf.gallery"
                  :gallery="dataCenter.acf.gallery"
                  :class="`data-center__gallery--${dataCenter.id}`"
                  :data-center-id="dataCenter.id"
                ></data-center-list-gallery>
              </div>
            </div>
          </div>
        </div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import DataCenterListGallery from './DataCenterListGallery'

export default {
  name: 'DataCenterList',
  components: {
    DataCenterListGallery
  },
  props: {
    dataCenters: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss">
.data-center { //Эти танцы с бубном чтобы растянуть полоску на весь экран,
  //при этом сохранив отступы как у всей страницы
  .ant-tabs-nav-container {
    width: 100%;
    max-width: 1600px;
    margin-right: auto;
    margin-left: auto;
    padding-left: 16px;
    padding-right: 16px;

    @media (min-width: 1200px) and (max-width: 1600px) {
      padding-left: 32px;
      padding-right: 32px;
    }

    @media (max-width: $breakpoint-lg) {
      padding-left: 10px;
      padding-right: 10px;
    }

    @media (max-width: $breakpoint-sm) {
      max-width: 100%;
    }
  }

  .ant-tabs-nav-container-scrolling {
    padding-right: 32px;
    padding-left: 32px;
  }

  .ant-tabs-nav-scroll {
    padding-left: calc(100% / 4 + 4px);

    @media (max-width: $breakpoint-xl) {
      padding-left: 0;
    }
  }

  .ant-tabs-bar {
    margin-bottom: 40px;

    @media (max-width: $breakpoint-md) {
      margin-bottom: 32px;
    }
  }
}

.data-center__info {
  width: 100%;
  display: grid;
  grid-template:
  'about swiper'
  / calc(100% / 3) calc(100% / 3 * 2); //с фракциями не работает, не знаю почему

  overflow: hidden;
  border: 1px solid rgba(9, 36, 51, 0.15);
  border-radius: 12px;

  @media (max-width: $breakpoint-lg) {
    grid-template:
    'swiper'
    'about'
     / 100%;
  }
}

.data-center__about {
  grid-area: about;
  height: 100%;
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;

  @media (max-width: $breakpoint-lg) {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  @media (max-width: $breakpoint-md) {
    padding: 24px 16px;
  }
}

.data-center__about .h2 {
  margin-bottom: 4px;
}

.data-center__specifications {
  padding-bottom: 24px;
  margin-bottom: auto;
  width: 100%;
  display: flex;
  flex-direction: column;

  @media (max-width: $breakpoint-lg) {
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 40px;
    padding-bottom: 0;
  }

  @media (max-width: $breakpoint-md) {
    margin-bottom: 24px;
  }
}

.data-center__specifications-item {
  margin-bottom: 24px;

  @media (max-width: $breakpoint-lg) {
    margin-bottom: 0;
    margin-right: 40px;
  }

  @media (max-width: $breakpoint-md) {
    margin-right: 10px;
  }

  &:last-of-type {
    margin-bottom: 0;
    margin-right: 0;
  }
}

.data-center__specifications-description {
  @media (max-width: $breakpoint-sm) {
    max-width: 72px;
  }
}

.data-center__about-address {
  margin-bottom: 0;
}

.data-center__address-group {
  padding-top: 16px;

  @media (max-width: $breakpoint-lg) {
    padding-top: 0;
  }
}

.data-center__title {
  max-width: 250px;

  @media (max-width: $breakpoint-xl) {
    max-width: none;
    margin-bottom: 24px;
  }

  @media (max-width: $breakpoint-md) {
    margin-bottom: 16px;
  }
}
</style>